// Play/pause overlay is handled via Alpine in block.blade.php.
common.View.create('canvas.blocks.custom.video.Block', {
    onDOMLoad() {},
});
